<template>
  <i class="bi bi-circle-fill"></i>
</template>
<style>
.bi-circle-fill {
  color: red;
  animation-name: fade;
  animation-duration: 5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}


@keyframes fade {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>